// src/components/store/sections/hero-banner/HeroV96MagazinecoverIndigoPulse.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV96MagazinecoverIndigoPulse(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={96}
      archKey="magazine_cover"
      archLabel="Luxury Magazine Cover"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      {...props}
    />
  );
}
